import { MasterMilestoneFindDto, type MasterMilestoneFindInterface } from '@zaoblako/shared/modules/catalog/dtos/master-milestone/master-milestone-find.dto';
import { DirectionFindDto, type DirectionFindInterface } from '@zaoblako/shared/modules/catalog/dtos/direction/direction-find.dto';
import { UnitFindDto, type UnitFindInterface } from '@zaoblako/shared/modules/catalog/dtos/unit/unit-find.dto';
import { FilialFindDto, type FilialFindInterface } from '@zaoblako/shared/modules/catalog/dtos/filial/filial-find.dto';
import { ClientFindDto, type ClientFindInterface } from '@zaoblako/shared/modules/client/dtos/client/client-find.dto';
import { UserFindDto, type UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { UserGroupFindDto, type UserGroupFindInterface } from '@zaoblako/shared/modules/security/dtos/user-group/user-group-find.dto';
import { DealFindDto, type DealFindInterface } from '@zaoblako/shared/modules/business/dto/deal/deal-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { ProjectDtoKeysEnum } from '@zaoblako/shared/modules/project/enum/project-dto-keys.enum';

import * as yup from 'yup';

/** Sub-project default values response body - DTO signature */
export interface SubprojectDefaultsFindInterface {
  /** Default subproject master milestone */
  masterMilestone?: MasterMilestoneFindInterface;
  /** Default subproject direction */
  direction?: DirectionFindInterface;
  /** Default subproject unit */
  unit?: UnitFindInterface;
  /** Default subproject filial */
  filial?: FilialFindInterface;
  /** Default subproject client */
  client?: ClientFindInterface;
  /** Default subproject user auditors */
  userAuditors?: UserFindInterface[];
  /** Default subproject group auditors */
  userGroupAuditors?: UserGroupFindInterface[];
  /** Default subproject deals */
  deals?: DealFindInterface[];
}

/** Sub-project default values response body - DTO schema */
export const SubprojectDefaultsFindDto = SerdeDtoClass.create<SubprojectDefaultsFindInterface>(ProjectDtoKeysEnum.SUBPROJECT_DEFAULTS_FIND_DTO, {
  masterMilestone: {
    optional: true,
    label: 'Мастер-веха',
    nested: MasterMilestoneFindDto,
    serializer: (_, nested) => nested,
  },
  direction: {
    optional: true,
    label: 'БС',
    nested: DirectionFindDto,
    serializer: (_, nested) => nested,
  },
  unit: {
    optional: true,
    label: 'БС',
    nested: UnitFindDto,
    serializer: (_, nested) => nested,
  },
  filial: {
    optional: true,
    label: 'Филиал',
    nested: FilialFindDto,
    serializer: (_, nested) => nested,
  },
  client: {
    optional: true,
    label: 'Клиент',
    nested: ClientFindDto,
    serializer: (_, nested) => nested,
  },
  userAuditors: {
    optional: true,
    label: 'Пользователи-аудиторы',
    nested: UserFindDto,
    serializer: (_, nested) => yup.array(nested),
  },
  userGroupAuditors: {
    optional: true,
    label: 'Группы-аудиторы',
    nested: UserGroupFindDto,
    serializer: (_, nested) => yup.array(nested),
  },
  deals: {
    optional: true,
    label: 'Сделки',
    nested: DealFindDto,
    serializer: (_, nested) => yup.array(nested),
  },
});
